<template>
  <detail
    :onManager="onManager"
    :data="data"
    :base-info="baseInfo"
    status-module="mcp"
    resource="mcp_servers"
    :hiddenKeys="['status']" />
</template>

<script>
import {
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import AiproxyRoutingLinkDetailMixin from '@Ai/mixins/aiproxyRoutingLinkDetailMixin'
import { getAiRoutingDetailField } from '@Ai/utils/aiproxyRoutingLinkColumns'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'McpDetail',
  mixins: [AiproxyRoutingLinkDetailMixin, WindowsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  computed: {
    baseInfo () {
      return [
        getAiRoutingDetailField(this, {
          routingName: this.aiRoutingName,
          emptyText: this.$t('ai.mcp.update_routing_required'),
          onEmptyClick: row => this.openMcpConfigDialog(row),
        }),
        {
          field: 'llm_driver',
          title: this.$t('ai.mcp.api_standard'),
          formatter: ({ row }) => {
            if (row.llm_driver === 'ollama') {
              return 'Ollama'
            } else if (row.llm_driver === 'openai') {
              return 'OpenAI'
            }
            return '-'
          },
        },
        {
          field: 'model',
          title: this.$t('ai.mcp.model'),
          formatter: ({ row }) => {
            return row.model || '-'
          },
        },
        getCopyWithContentTableColumn({
          field: 'llm_url',
          title: this.$t('ai.mcp.llm_url'),
        }),
        getCopyWithContentTableColumn({
          field: 'mcp_server',
          title: this.$t('ai.mcp.mcp_server'),
        }),
        {
          field: 'default_agent',
          title: this.$t('ai.mcp.default_agent'),
          slots: {
            default: ({ row }) => {
              return row.default_agent ? [<status specifyStatus={{ class: 'status-success', text: this.$t('common.true') }} />] : [<status specifyStatus={{ class: 'status-info', text: this.$t('common.false') }} />]
            },
          },
        },
      ]
    },
  },
  methods: {
    openMcpConfigDialog (row) {
      const data = row || this.data
      if (!data) return
      this.createDialog('McpConfigDialog', {
        type: 'edit',
        data: [data],
        onManager: this.onManager,
      })
    },
  },
}
</script>
